import { SET_ERROR, RESET_ERROR } from './actionTypes'
import { ErrorActionTypes } from './types'

const initialState = {
  title: '',
  text: '',
  buttons: [], 
  icon: ''
}

export default (state = initialState, action: ErrorActionTypes) => {
  switch (action.type) {
    case SET_ERROR:
      return { ...state, ...action.payload };
    case RESET_ERROR:
      return initialState;
    default:
      return state;
  }
}
